import React, { useEffect, useState } from "react";
import "./Transactions.scss";
import { Searchbar } from "../../../../components";
import { useSelector } from "react-redux";
import {  getPlanDetailsFromPlanID, setAllTransactions } from "../../../../utils/services/user";
import moment from "moment";
import { normalizeTimestamp } from "../../../../utils/services/other";

function Transactions(): JSX.Element {
  const otherDataStore = useSelector((store: any) => store?.otherData);
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [orignalItems, setOrignalItems] = useState<any[]>([]);

  useEffect(() => {
    let isMounted = true;
    isMounted &&
      (async () => {
        let transactions = await setAllTransactions();
        setCurrentItems(transactions);
        setOrignalItems(transactions);
      })();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="Transactions">
    <div className="Transactions__FilterBar">
      <div className="searchBar">
        <Searchbar
          orignalItems={orignalItems}
          setCurrentItems={setCurrentItems}
          placeholder={"Search Transaction ID / Amount"}
          primaryConditionKey={"id"}
          secondaryConditionKey={"amount"}
        />
      </div>
    </div>
    <div className="Transactions__TableBox">
      <table>
        <thead>
          <tr className="tableHead">
            <th>Transaction ID</th>
            {!otherDataStore?.isMobile ? (
              <>
                <th>Plan</th>
                <th>Date</th>
                <th>Network</th>
                <th>Amount</th>
              </>
            ) : (
              <></>
            )}
          </tr>
        </thead>
        <tbody>
          {currentItems.map((item, index) => (
            <tr key={index}>
              <td>{item?.id}</td>
              <td>{getPlanDetailsFromPlanID(item?.planID)?.title}</td>
              <td> {moment(normalizeTimestamp(item?.createdAt)).format("DD-MM-YYYY")}</td>
              <td>{item?.network}</td>
              <td>{item?.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
 
  );
}

export default Transactions;
